export default __webpack_public_path__ + "static/media/mobile.23686ea4.jpg";